import { ReactComponent as ArrowRight } from 'assett/icons/arrow_right_claim_detail.svg';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Typography from 'styles/typography/Typograpy';

interface Props {
	sign: string;
}

export enum Sign {
	PLUS = '+',
	MINUS = '-',
	EQUAL = '=',
	AND = '&',
	ARROW = 'arrow',
}

const ClaimsOperationIcon = (props: Props) => {
	const [value, setValue] = useState<string>();

	useEffect(() => {
		switch (props.sign) {
			case Sign.EQUAL:
				setValue('=');
				break;
			case Sign.PLUS:
				setValue('+');
				break;
			case Sign.MINUS:
				setValue('-');
				break;
			case Sign.AND:
				setValue('&');
				break;
			case Sign.ARROW:
				setValue('arrow');
				break;
		}
	}, [props.sign]);

	return (
		<OperationIcon variant={value === Sign.AND ? 'body' : 'bodyLink'}>
			{value === Sign.ARROW ? <ArrowRight /> : value}
		</OperationIcon>
	);
};

export default ClaimsOperationIcon;

const OperationIcon = styled(Typography)`
	border: 1px solid #b4b4b4;
	border-radius: 100%;
	display: inline-flex;
	width: 24px;
	height: 24px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	gap: 10px;
`;
